export { default } from './RecentlyReturnedAddToShelf';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedAddToShelf/index.js